import { Form, Input, Switch } from "antd";
import { forwardRef } from "react";

const InsertMenuGroup = forwardRef(({ dataSource }, insertMenuGroupRef) => {

  function validator(_, value) {
    const newData = insertMenuGroupRef.current.getFieldsValue();
    for (let el of dataSource) {
      if (
        el.id !== newData.menuGroupId &&
        el.menu_group_name === newData.menuGroupName
      ) {
        return Promise.reject(
          new Error(`메뉴그룹에 "${el.menu_group_name}"가 이미 존재합니다.`)
        );
      }
    }
    return Promise.resolve();
  }

  return (
    <div>
      <Form
        layout="vertical"
        initialValues={{ MFA_yn: false }}
        ref={insertMenuGroupRef}
      >
        <Form.Item
          name="menuGroupName"
          label="영역명칭"
          rules={[
            { required: true, message: "영역명칭을 입력해 주세요." },
            { validator: validator },
          ]}
        >
          <Input></Input>
        </Form.Item>
        <Form.Item
          label="MFA 인증 필요"
          name="MFA_yn"
          valuePropName="checked"
          required={true}
        >
          <Switch defaultChecked={false}></Switch>
        </Form.Item>
      </Form>
    </div>
  );
});

export default InsertMenuGroup;
